module.exports = __webpack_public_path__ + "img/contact.29b561c5.png";